export default __webpack_public_path__ + "static/media/tool-field-indoor-full.6a2a3aff.svg";